import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { urlServer } from '../global_constants';
import { ServiceResponse } from '../models/service-response';

@Injectable({
  providedIn: 'root'
})
export class SalesService {

  token:any;
  //REF NEW SALE VARIABLES
  newSaleSubject:Subject<any>;
  salesSubject:Subject<any>;
  advancedSearchSubject:Subject<any>;
  customersGoalsSubject:Subject<any>;

  pathApiSaleOperations:string="/v1/sale";
  urlRequestSale: string =urlServer.concat(this.pathApiSaleOperations);
  pathApiSales:string="/v1/sales";
  urlRequestSales: string =urlServer.concat(this.pathApiSales);
  pathApiCustomersGoal:string="/v1/customers/goals";
  urlRequestCustomersGoals: string =urlServer.concat(this.pathApiCustomersGoal);

  //Retrieve cover sales statistics
  pathApiStatiscticsCover:string="/v1/sales/cover/commercial/";
  urlRequestStatiscticsCover: string =urlServer.concat(this.pathApiStatiscticsCover);

  //Retrieve Details cover sales statistics
  pathApiDetailsCover:string="/v1/sales/coverDetails/commercial/";
  urlRequestDetailsCover: string =urlServer.concat(this.pathApiDetailsCover);

  //Retrieve Details cover sales statistics
  pathApiDetailsIndicCover:string="/v1/sales/coverIndicatorsDetails/commercial/";
  urlRequestDetailsIndicatorsCover: string =urlServer.concat(this.pathApiDetailsIndicCover);

  constructor(private httpClient:HttpClient) {
    this.newSaleSubject = new Subject();
    this.salesSubject = new Subject();
    this.customersGoalsSubject = new Subject();
    this.advancedSearchSubject = new Subject();
    if(localStorage.getItem("token")!=null && localStorage.getItem("token")!=undefined) 
      this.token = localStorage.getItem("token")
    else this.token = sessionStorage.getItem("token")
  }

  newSaleRequest:any;
  newSale() {
    this.newSaleSubject = new Subject();
    const body = this.newSaleRequest;
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.post(this.urlRequestSale, body,{headers: header}).subscribe((response: any) => {
        this.newSaleSubject.next(response);
        this.newSaleSubject.complete();
    },
      error => {
        console.error('There was an error!', error);
      }
    );
  }

  getSalesOfCustomerByYear(year:any, customer:any){
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + this.token);
    return this.httpClient.get<any>(this.urlRequestSales+"/"+year+"/"+customer,{headers: header});
  }
  getAllSales(){
     let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + this.token);
    return this.httpClient.get<any>(this.urlRequestSales,{headers: header});
  }

  advancedSearchRequest:any;
  advancedSearchSales(){
    this.advancedSearchSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.post(this.urlRequestSales+"/advanced",this.advancedSearchRequest,{headers: header}).subscribe((response: any) => {
      this.advancedSearchSubject.next(response);
      this.advancedSearchSubject.complete();
    },)
  }

  getCustomersGoals(month:string, year:string,
    pageSize: number = 5,
    criticalPage: number = 0,
    warningPage: number = 0,
    successPage: number = 0
  ){
      this.customersGoalsSubject = new Subject();
      const body = {
        year:year,
        month:month,
        pageSize: pageSize,
        criticalPage: criticalPage,
        warningPage: warningPage,
        successPage: successPage
      };
      let header: HttpHeaders = new HttpHeaders();
      header = header.set('authorization', "Bearer "+this.token );
      this.httpClient.post(this.urlRequestCustomersGoals, body,{headers: header}).subscribe((response: any) => {
        console.log(response);
        this.customersGoalsSubject.next(response);
        this.customersGoalsSubject.complete();
      },
        error => {
          console.error('There was an error!', error);
        }
      );
  }

  getSalesStatisticsCover(commercial:any): Observable<ServiceResponse>{
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    return  this.httpClient.get<ServiceResponse>(this.urlRequestStatiscticsCover+commercial,{headers: header});
  }
  getSalesDetailsCover(commercial:any): Observable<ServiceResponse>{
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    return  this.httpClient.get<ServiceResponse>(this.urlRequestDetailsCover+commercial,{headers: header});
  }
  getSalesDetailsIndicators(commercial:any): Observable<ServiceResponse>{
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    return  this.httpClient.get<ServiceResponse>(this.urlRequestDetailsIndicatorsCover+commercial,{headers: header});
  }

  getSalesOfVisit(visitId:any){
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + this.token);
    return this.httpClient.get<any>(this.urlRequestSales+"/visit/"+visitId,{headers: header});
  }

}
